import React, { useState, useEffect } from "react";
import Modal from "../ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import VideoPlayer from "@components/VideoPlayer";
import { fetchData } from "@app/Helpers";
import DOMPurify from "dompurify";
import { getUserDetails } from "@api/consumer";
import { useQuery } from "@tanstack/react-query";
import StoryPoints from "@components/StoryPoints";

export default NiceModal.create(() => {
  const modal = useModal();
  const [secondsWatched, setSecondsWatched] = useState(false);
  const [showPoints, setShowPoints] = useState(false);

  const video = modal.args?.video;
  const videoTime = modal.args?.videoTime;
  const image = modal.args?.image;
  const ident = modal.args?.ident;
  const ultraInsider = modal.args?.ultraInsider;
  const fetchAllActivations = modal.args?.fetchAllActivations;
  const completed = modal.args?.completed;

  const detailsQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    enabled: !!localStorage.getItem("token"),
  });

  useEffect(() => {
    if (showPoints) {
      const timeout = setTimeout(() => {
        setShowPoints(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [showPoints]);

  async function VideoPoints() {
    if (ultraInsider && !completed) {
      fetchData({
        endpoint: "/activation/solution/create",
        payload: {
          activation: {
            ident: DOMPurify.sanitize(ident),
            payload: null,
          },
        },
        successCallback: () => {
          setShowPoints(true);
          detailsQuery.refetch();
        },
      });
    }
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => {
        modal.remove();
        if (ultraInsider) {
          fetchAllActivations();
        }
      }}
      innerClass={`video-modal`}
    >
      <div className="content-wrapper">
        <VideoPlayer
          placeholder={image}
          videoSrc={video}
          onTimeWatchedFunction={VideoPoints}
          onTimeWatchedFunctionTriger={videoTime}
          secondsWatched={secondsWatched}
          setSecondsWatched={setSecondsWatched}
          controlList={"nodownload nofullscreen"}
        />
        {showPoints && (
          <StoryPoints fill={100} animate={true} bonus={0}>
            5
          </StoryPoints>
        )}
      </div>
    </Modal>
  );
});
